<div
  id="sidebar-container"
  [style]="{
  '--outer-sidebar-background-color': sidebarBackgroundColor,
  '--outer-sidebar-background-color-hover': sidebarBackgroundColorHover
  }"
  [class]="{
    'expand-menu': !collapsedMenu(),
    'collapse-menu': collapsedMenu()
  }"
>
  <div class="logo-wrapper">
    <a routerLink="/companies">
      <img
        ngSrc="../../../../assets/svg/pravo-logo-white.svg"
        priority
        alt="Logo"
        class="logo"
        height="60"
        width="60"
      />
    </a>
  </div>

  <div class="menu-container">
    <div class="menu-wrapper">
      <div>
        @for (item of menuItems(); track item) {
          @if (!(environment.production && item.hideProd)) {
            <app-nav-menu-link
              [isTopLevelElement]="true"
              [navMenuitemData]="item"
              [collapsedMenu]="collapsedMenu()"
              [expanded]="item.opened ?? false"
            />
          }
        }
      </div>

      @if (authService.isSuperuser) {
        <div class="menu-heading superuser-dark">
          {{ collapsedMenu() ? '' : 'Superuser' }}
        </div>

        <div class="superuser-dark">
          @for (item of sauperUserMenuItems; track $index) {
            <app-nav-menu-link
              [isTopLevelElement]="true"
              [navMenuitemData]="item"
              [collapsedMenu]="collapsedMenu()"
            />
          }
        </div>
      }
    </div>

    <div class="toggle-btn-container">
      <div class="menu-item" (click)="toggleMenu()">
        <div class="menu-icon">
          <i
            class="icon"
            [class]="{'ic-collapse-20': !collapsedMenu(), 'ic-expand-20': collapsedMenu()}"
          ></i>
        </div>
      </div>
    </div>
  </div>
</div>
